module.exports = __webpack_public_path__ + "assets/img/reverse-sweep-3.b8dd0486.jpg";